export enum TimerStatus {
  INIT = 'init',
  STOP = 'stop',
  PAUSE = 'pause',
  RESET = 'reset',
  START = 'start',
  TIMEOVER = 'timeover',
}
